import React from 'react';
import { MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImage, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import styles from './Images.module.scss';
import { ImageInfo } from '../annotation.types';
type DataNode = any;

const minusCircleFilled = <MinusCircleFilled style={{ color: '#321850' }} />;
const plusCircleFilled = <PlusCircleFilled style={{ color: '#321850' }} />;

const switcherIcon = ({ expanded }: any) => (expanded ? minusCircleFilled : plusCircleFilled);

function hasChildren(images: ImageInfo[], parentName: string | null): boolean {
  return images.filter(x => x.parentFilename === parentName).length > 0;
}
const chooseSwitcherIcon = (images: ImageInfo[], image: ImageInfo) => {
  return hasChildren(images, image.filename) ? switcherIcon : minusCircleFilled;
};

function getChildren(images: ImageInfo[], parentName: string | null): DataNode[] {
  return images
    .filter(x => x.parentFilename === parentName)
    .map(x => ({
      title: (
        <span>
          <FontAwesomeIcon
            icon={faFileImage}
            className={classNames(styles.photocard, {
              [styles.hidden]: !(x.isPhotocard || x.isDetailed)
            })}
          />
          {x.filename}
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className={classNames(styles.qcIssues, {
              [styles.hidden]: !x.haveQC
            })}
          />
        </span>
      ),
      key: x.filename,
      switcherIcon: chooseSwitcherIcon(images, x),
      selectable: true,
      children: getChildren(images, x.filename)
    }));
}

export function prepareTreeStructure(images: ImageInfo[]) {
  const structure: DataNode[] = getChildren(images, null);

  return structure;
}
